import api from '../api'

const getStats = token => {
  return api.privateGet(`/v1/stats/`, { token })
}

export default {
  getStats
}
